var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crowd-picker-content as-flex main-end cross-center" },
    [
      _c("el-cascader", {
        attrs: { options: _vm.formatOptions, value: _vm.current_crowd },
        on: { change: _vm.handleChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }